import { useCallback, ReactElement } from 'react'
import { Form, Input, Modal } from 'antd'

import { updateDecisionFolder } from '@vms/vmspro3-core/dist/actions/decision'

import { useAppDispatch } from '../../../redux'
import { DecisionFolderLite } from '../../../types/decisionTypes'

export type DecisionFolderEditModalProps = {
  decisionFolder: DecisionFolderLite
  hide: VoidFunction
}
export function DecisionFolderEditModal({ decisionFolder, hide }: DecisionFolderEditModalProps): ReactElement {
  const [form] = Form.useForm<{ name: string }>()

  const dispatch = useAppDispatch()
  const onOk = useCallback(
    () =>
      form.validateFields().then(({ name }) => {
        dispatch(updateDecisionFolder(decisionFolder.id, { name }))
        hide()
      }),
    [form, dispatch, decisionFolder.id, hide]
  )

  return (
    <Modal open onOk={onOk} onCancel={hide}>
      <h3>Editing {decisionFolder.name}</h3>
      <Form form={form} layout="vertical" initialValues={decisionFolder}>
        <Form.Item label="Name" name="name">
          <Input autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  )
}
